import React, { useState, useEffect } from 'react';
import Pokemon from '../Pokemon/Pokemon';
import Interface from '../Interface/Interface';
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import EndingScreen from  "../EndingScreen/EndingScreen";
import spellsList from './movesList.json';
import './Fight.css';

const Fight = ({ opponents, setPlayerPoints }) => {

    const [attackLaunched, setAttackLaunched] = useState({});
    const [players, setPlayers] = useState([]);
    const [ready, setReady] = useState(false);
    const [canPlay, setCanPlay] = useState(true);
    const [gameEnded, setGameEnded] = useState(false);

    useEffect(() => {
        getPokemons();
    }, []);

    const setPokemonLevel = (pokemonExperience) => {
        for (let level = 0; level < 100; level++) {
            const experienceNeeded = Math.pow(level, 3)
            if (pokemonExperience > experienceNeeded / 2 && pokemonExperience < experienceNeeded +  (experienceNeeded / 2)) {
                return level + 1; 
            }
        }
    }

    const getPokemons = () => {
        const pokemonList = [];
        Promise.all(opponents.map(pokemonName =>
            fetch(`https://pokeapi.co/api/v2/pokemon/${pokemonName}`)
            .then(res => res.json())
            .then(res => res) 
        ))
        .then(data => {
            // Filtrage des données de l'API
            data.map(pokemon =>  {
                const name = pokemon.name;
                const types = pokemon.types;
                const level = setPokemonLevel(pokemon.base_experience);
                const pokemonTypes = types.map(type => type.type.name);
                const spellType =  spellsList.find(spell => pokemonTypes.includes(spell.type));
                const normalSpells = spellsList[3];


                const spells = [
                    {...spellType.direct_damage_spells[random(0, 2, false)], type: spellType.type },
                    {...spellType.indirect_damage_spells[random(0, 2, false)], type: spellType.type },
                    {...normalSpells.direct_damage_spells[random(0, normalSpells.direct_damage_spells.length, false)], type: "normal" },
                    {...normalSpells.direct_damage_spells[random(0, normalSpells.direct_damage_spells.length, false)], type: "normal" }
                ];

                const [fullHP, speed, attack, defense] = [getStat("hp", pokemon), 
                                                                                                getStat("speed", pokemon), 
                                                                                                getStat("attack", pokemon), 
                                                                                                getStat("defense", pokemon)];
                pokemonList.push({name, types, level, fullHP, currentHP: fullHP, speed, attack, defense, spells});
            });

            setPlayers([{
                ...pokemonList.filter(pokemon => pokemon.name === opponents[0])[0], 
                key: "player",
                back: true,
                playerName: "player"
            },
            {
                ...pokemonList.filter(pokemon => pokemon.name === opponents[1])[0], 
                key: "enemy",
                playerName: "enemy"
            }]);
            setReady(true);
            //setGameEnded(true);
        });
    }

    const getStat  =(statWanted, pokemon) => {
        return pokemon.stats.find(stat => stat.stat.name === statWanted).base_stat;
    }

    // Fonction qui recupere les infos du sort envoyé de Interface
    const getLaunchedSpell = (spellInfo) => {
        // Recuperer le joueur qui a lancé le sort
        const player = players.find(player => player.playerName === spellInfo.playerName);
        player.hitAnimation = false;
        // Récuperer la cible ce celui-ci (donc l'autre joueur)
        const playerIndex = players.indexOf(player);
        const target = players[(playerIndex + 1) % players.length];
        // Calculer les degats grâce aux infos de chacun et ajouter une propriété de dégats reçu à la cible
        const attackerDamage = (player.level * 0.4 + 2) * player.attack * spellInfo.power;
        const defenser = (target.defense* 50);
        const STAB = player.types.find(type => type.type.name === spellInfo.type) ? 1.5 : 1;

        // Gestion PP (suppression du sort si PP nul)
        const playerSpells = player.spells;
        const launchedSpell = playerSpells.find(spell => spell.name === spellInfo.name);
        launchedSpell.pp--;
        if (!launchedSpell.pp) playerSpells.splice(playerSpells.indexOf(launchedSpell), 1);

        const damage = Math.round(((attackerDamage / defenser) + 2 ) * STAB * random(0.85, 1, true));
        target.currentHP -= damage;
        if (target.currentHP < 0) { 
            target.currentHP = 0;
        }

        target.hitAnimation = true;

        const isGameEnded = players.find(player => player.currentHP <= 0);
        setGameEnded(isGameEnded);

        if (!isGameEnded) {
            if (player.playerName === "player") {
                setCanPlay(false);
                AI();
            } else {
                setCanPlay(true);
            }
        }
    }

    const AI = () => {
        const spell = players[1].spells[random(0, players[1].spells.length)]
        const spellInfo = {
            playerName: "enemy",
            type: spell.type,
            accuracy: spell.accuracy,
            power: spell.power,
            name: spell.name,
            pp: spell.pp
        }
        const waitBeforeAttack = setTimeout(() => {
            getLaunchedSpell(spellInfo)
            clearTimeout(waitBeforeAttack)
        }, 1500);
    }

    const random  = (min, max, relative = false) => {
        // Fonction avec possiblité de relativité (nombre décimal autorisé ou non)
        const relativeRandom = Math.random() * (max - min);
        const integerRandom = Math.floor(relativeRandom);
        return (relative ? relativeRandom : integerRandom) + min;
    }
                                                             
    return (
        <div className="Fight-container">
            { gameEnded ? <EndingScreen ending={players[0].currentHP ? "VICTORY" : "GAME OVER" } pointsGained={random(200, 500)} setPlayerPoints={setPlayerPoints} /> : null }
            <div className="Fight">
                {
                  ready &&
                    <div className="Fight-combat">
                        {
                            players.map(pokemon => <Pokemon {...pokemon} />) 
                        }
                    </div>
                }
                {(ready) && <Interface  {...players[0]} sendSpell={getLaunchedSpell} canPlay={canPlay} gameEnded={gameEnded} />}
                { <LoadingScreen finishedState={ready} />}
            </div> 
        </div>
    );
}

export default Fight;